import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { changeRootClass } from '../../../utils/dom';
import { FullScreenControls } from '../full_screen_controls';
import { iconNoPhoto } from './icon_no_photo';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var START_SHOWED_ELEMENT = 0;
var createFotoramaData = function createFotoramaData(_ref) {
  var photos = _ref.photos;
  return (photos || []).map(function (photo) {
    return {
      img: photo.fullUrl,
      thumb: photo.thumbnailUrl
    };
  });
};
export var Fotorama = /*#__PURE__*/function (_React$Component) {
  _inherits(Fotorama, _React$Component);
  var _super = _createSuper(Fotorama);
  function Fotorama(props) {
    var _this;
    _classCallCheck(this, Fotorama);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "fotoramaRef", null);
    _defineProperty(_assertThisInitialized(_this), "$fotorama", void 0);
    _defineProperty(_assertThisInitialized(_this), "fotorama", void 0);
    _defineProperty(_assertThisInitialized(_this), "fragmentContainer", null);
    _defineProperty(_assertThisInitialized(_this), "flatInfoContainer", null);
    // переопределение стилей галлереи в карточке ЖК для полноэкранного режима
    _defineProperty(_assertThisInitialized(_this), "onFullScreenEnter", function () {
      changeRootClass('mvk_fotorama_root_fullscreen', true);
      document.body.className += ' mvk_fotorama_fullscreen';
      _this.setState({
        isFullScreen: true
      });
      _this.handleFotoramaResize();
    });
    _defineProperty(_assertThisInitialized(_this), "onFullScreenExit", function () {
      document.body.className = document.body.className.replace('mvk_fotorama_fullscreen', '');
      _this.fotorama.cancelFullScreen();
      _this.setState({
        isFullScreen: false
      });
      _this.handleFotoramaResize();
      setTimeout(function () {
        changeRootClass('mvk_fotorama_root_fullscreen', false);
      }, 0);
    });
    _defineProperty(_assertThisInitialized(_this), "handleFotoramaResize", function () {
      if (_this.fotorama) {
        _this.fotorama.setOptions({
          ratio: _this.getFotoramaRatio()
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getFotoramaRatio", function () {
      if (!_this.fotoramaRef || !_this.flatInfoContainer || !_this.fragmentContainer) {
        return 1;
      }
      var isMVKFullScreen = _this.props.isMVKFullScreen;
      var flatInfoHeight = _this.flatInfoContainer.clientHeight;

      // Расчет высоты для фоторамы
      var clientHeight = isMVKFullScreen ? window.innerHeight - 240 : _this.fragmentContainer.clientHeight - Math.max(130, flatInfoHeight) - 100;
      return _this.fotoramaRef.clientWidth / clientHeight;
    });
    _this.state = {
      isFullScreen: false
    };
    return _this;
  }
  _createClass(Fotorama, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (window.$ && this.fotoramaRef) {
        this.initFotorama(this.props.flat);
      }
      this.fragmentContainer = document.getElementById('newbuilding_mvk_fragment-main_block');
      this.flatInfoContainer = document.getElementById('newbuilding_mvk_fragment-flat_info');
      window.addEventListener('resize', this.handleFotoramaResize);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.flat.id !== nextProps.flat.id) {
        if (this.fotorama) {
          this.fotorama.load(createFotoramaData(nextProps.flat));
          this.fotorama.show(START_SHOWED_ELEMENT);
        } else if (window.$ && this.fotoramaRef) {
          this.initFotorama(nextProps.flat);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.$fotorama) {
        this.$fotorama.unbind();
      }
      window.removeEventListener('resize', this.handleFotoramaResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        flat = _this$props.flat,
        builder = _this$props.builder,
        isOfferCard = _this$props.isOfferCard;
      var withItems = (flat.photos || []).length > 0;
      return /*#__PURE__*/_jsxs("div", {
        className: styles['fotorama_container'],
        children: [this.state.isFullScreen && /*#__PURE__*/_jsx(FullScreenControls, {
          flat: flat,
          exitFullscreen: this.onFullScreenExit,
          builder: builder,
          isOfferCard: isOfferCard
        }), /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(!withItems && styles['hidden'])), {}, {
          children: /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(styles['fotorama'], 'mvk_fotorama')), {}, {
            "data-width": "100%",
            "data-nav": "thumbs",
            "data-fit": "contain",
            "data-keyboard": "true",
            "data-loop": "false",
            "data-thumbwidth": "85",
            "data-thumbheight": "60",
            "data-arrows": "true",
            "data-swipe": "false",
            "data-thumbmargin": "4",
            "data-auto": "false",
            "data-allowfullscreen": "true",
            ref: function ref(fotorama) {
              return _this2.fotoramaRef = fotorama;
            }
          }))
        })), !withItems && /*#__PURE__*/_jsx("div", {
          className: styles['default_content'],
          children: iconNoPhoto
        })]
      });
    }
  }, {
    key: "initFotorama",
    value: function initFotorama(flat) {
      this.$fotorama = window.$(this.fotoramaRef).fotorama({
        data: createFotoramaData(flat),
        minheight: '200',
        ratio: this.getFotoramaRatio(),
        startindex: START_SHOWED_ELEMENT
      });
      this.fotorama = this.$fotorama.data('fotorama');
      this.$fotorama.on('fotorama:fullscreenenter', this.onFullScreenEnter);
      this.$fotorama.on('fotorama:fullscreenexit', this.onFullScreenExit);

      // Выставление корректного ратио фоторамы после инициализации плагина
      setTimeout(this.handleFotoramaResize, 0);
    }
  }]);
  return Fotorama;
}(React.Component);